import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import PurchaseOrders from 'types/entities/PurchaseOrders';

const PriceCell = React.memo((row: PurchaseOrders) => {
  let devise_symbol;
  if (row.pocurrency === 'USD' || row.pocurrency === 'CAD') {
    devise_symbol = '$';
  } else if (row.pocurrency === 'EUR') {
    devise_symbol = '€';
  } else if (row.pocurrency === 'GPB') {
    devise_symbol = '£';
  }

  return (
    <Tooltip arrow title={row.poservice ?? ''}>
      <Typography noWrap variant="body2">
        {row?.poservice} {devise_symbol}
      </Typography>
    </Tooltip>
  );
});

export default PriceCell;
